import gql from 'graphql-tag'

export const SALVAR_GRUPO_USUARIOS = gql`
  mutation SalvarGrupoUsuariosMutation($grupoUsuarios: GrupoUsuariosInput!) {
    salvarGrupoUsuarios(grupoUsuarios: $grupoUsuarios) {
      id
      nome
    }
  }
`
